import * as amplitude from '@amplitude/analytics-browser'

type AmplitudePropertyValue = string | number | boolean | null | undefined

export const useAmplitude = () => {
  const track = (eventName: string, eventProperties?: Record<string, AmplitudePropertyValue>) => {
    amplitude.track(eventName, eventProperties)
  }

  const identify = (userId: string, userProperties?: Record<string, AmplitudePropertyValue>) => {
    amplitude.setUserId(userId)
    if (userProperties) {
      const identifyEvent = new amplitude.Identify()
      Object.entries(userProperties).forEach(([key, value]) => {
        if (value !== undefined) {
          // @ts-expect-error - Amplitude types are restrictive
          identifyEvent.set(key, value)
        }
      })
      amplitude.identify(identifyEvent)
    }
  }

  const setUserProperties = (properties: Record<string, AmplitudePropertyValue>) => {
    const identifyEvent = new amplitude.Identify()
    Object.entries(properties).forEach(([key, value]) => {
      if (value !== undefined) {
        // @ts-expect-error - Amplitude types are restrictive
        identifyEvent.set(key, value)
      }
    })
    amplitude.identify(identifyEvent)
  }

  const reset = () => {
    amplitude.reset()
  }

  const flush = () => {
    amplitude.flush()
  }

  return {
    track,
    identify,
    setUserProperties,
    reset,
    flush,
  }
}
